function getDate(date: string | Date | null | undefined) {
  if (!!date) {
    return new Date(date)
  }
  return null
}

export function formatShortDate(input: string | Date | null | undefined) {
  const date = getDate(input)
  if (date) return date.toLocaleDateString("en-AU", {
    day: "numeric",
    month: "short",
    year: "numeric"
  })
}

export function formatFilesize(size: number) {
  if (size < 1024) {
    return Math.round(size) + 'B'
  } else if (size < 1024 * 1024) {
    return Math.round(size / 1024) + 'KB'
  } else if (size < 1024 * 1024 * 1024) {
    return Number(size / 1024 / 1024).toFixed(2) + 'MB'
  } else if (size < 1024 * 1024 * 1024 * 1024) {
    return Number(size / 1024 / 1024 / 1024).toFixed(2) + 'GB'
  }
}